import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpService } from 'src/app/services/http/http.service';
import { UpdateActivityState } from '../models/update-activity-state';

@Injectable({
    providedIn: 'root'
})
export class UpdateService extends HttpService {
    cancelActivity(activityState: UpdateActivityState): Observable<unknown> {
        const url = `schedules/${activityState.id}/cancel`;

        return this.post(url, {app: 'booking', version: 2}, activityState);
    }

    validateActivity(activityState: UpdateActivityState): Observable<unknown> {
        const url = `schedules/${activityState.id}/validate`;

        return this.post(url, { app: 'booking', version: 2}, activityState);
    }

    removeTask(idTask: number): Observable<unknown> {
        const url = `tasks/deleteassigntask/${idTask}`;

        return this.delete(url, { app: 'center', version: 1 }, this.showSuccessMessage('correct_task_remove'));
    }

    validateTask(idTask: number): Observable<unknown> {
        const url = `tasks/validateassigntask/${idTask}`;

        return this.post(url, { app: 'center', version: 1 }, { }, this.showSuccessMessage('tarea_validada_correctamente'));
    }

    removeService(idService: number): Observable<unknown> {
        const url = `services/deleteassignservice/${idService}`;

        return this.delete(url, { app: 'center', version: 1 }, this.showSuccessMessage('correct_remove_service'));
    }

    validateService(idService: number): Observable<unknown> {
        const url = `services/validateassignservice/${idService}`;

        return this.post(url, { app: 'center', version: 1 }, { }, this.showSuccessMessage('correct_service_validate'));
    }

    getServiceData(id: number): Observable<any> {
        return this.get(`services/${id}`, { app: 'center', version: 1 });
    }

    getTaskData(id: number): Observable<any> {
        return this.get(`tasks/${id}`, { app: 'center', version: 1 });
    }
}
